import React, { Component } from "react";
import { Link } from "@reach/router";
import { Tooltip } from "devextreme-react";
import Auth from "Api/Auth";
import Header from "components/common/StartupCard/Header";
import Footer from "components/common/StartupCard/Footer";
export default class StartupCard extends Component {
  constructor(props) {
    super(props);
    this.moderator = Auth.decodedToken().moderator;
    this.state = {
      showTooltip: false
    };
    this.toggleToolTip = () => {
      this.setState({ showTooltip: !this.state.showTooltip });
    };
  }

  render() {
    return (
      <>
        <div className="card" data-highlight={this.props.data.id}>
          <Header
            data={this.props.data}
            type={this.props.type}
            stakeData={this.props.stakeData}
          />
          <Link
            to={`/startup/${this.props.data.id}`}
            state={{ data: this.props.data }}
          >
            <div
              className="card-body startup-card-body"
              id={`startup${this.props.data.id}`}
              onMouseEnter={this.toggleToolTip}
              onMouseLeave={this.toggleToolTip}
            >
              <h4
                className="card-title text-capitalize text-center"
                title={this.props.data.registered_name}
                style={{ fontWeight: 400 }}
              >
                {this.props.data.name}
              </h4>
              <div className="text-center">
                <span
                  className="badge badge-pill badge-info"
                  title={this.props.data.industry.display_name}
                >
                  {this.props.data.industry.name}
                </span>
              </div>
              <div className="row text-center">
                <div
                  className="col card-category truncate"
                  title={this.props.data.state}
                >
                  <i className="im im-location"></i>
                  {this.props.data.state}
                </div>
                <div className="col card-category" title="Incorporation Year">
                  <i className="im im-calendar"></i>
                  {this.props.data.incorporation_year}
                </div>
              </div>
              <div className="row text-center">
                <div className="col card-category" title="Revenue">
                  <i className="im im-coin"></i>
                  {this.props.data.revenue}
                </div>
                <div className="col card-category" title="Gross Profit">
                  <i className="im im-coin"></i>
                  {this.props.data.gross_profit}
                </div>
              </div>
              <div className="row text-center">
                <div className="col card-category" title="Team Size">
                  <i className="im im-users"></i>
                  {this.props.data.team_size}
                </div>
                <div className="col card-category" title="Pitch Deck">
                  <a href={this.props.data.pitch_deck_pdf_upload} className="">
                    <i className="im im-paper-clip"></i>
                  </a>
                </div>
              </div>
            </div>
            <Tooltip
              target={`#startup${this.props.data.id}`}
              visible={this.state.showTooltip}
              position={"right"}
              closeOnOutsideClick={true}
            >
              <div>
                <span style={{ marginRight: 5, fontWeight: 500 }}>
                  Total investment raise till date
                </span>
                $ {this.props.data.total_investment_raise_till_date}
              </div>

              {this.props.data.last_amount_raised ? (
                <div>
                  <span style={{ marginRight: 5, fontWeight: 500 }}>
                    Last amount raised
                  </span>
                  $ {this.props.data.last_amount_raised}
                </div>
              ) : null}
            </Tooltip>
          </Link>
          {this.props.hideFooter ? null : (
            <>
              <div className="dropdown-divider"></div>
              <Footer
                moderator={this.moderator}
                data={this.props.data}
                type={this.props.type}
                action={this.props.action}
                showPopup={this.props.showPopup}
                stakeData={this.props.stakeData}
              />
            </>
          )}
        </div>
      </>
    );
  }
}
